import EmpNotesPage from "../Employee/EmpNotesPage";
import api from "../../services/api";

function NotesPg() {
  return (
    <EmpNotesPage
      notesApi={{
        getNotes: api.getHrNotes,
        addNote: api.addHrNote,
        updateNote: api.updateHrNote,
        deleteNote: api.deleteHrNote
      }}
    />
  );
}

export default NotesPg;
